import { Stack, Button, Box, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import theme from "../../../../../theme";
import { NAVIGATION_BUTTON_STYLES } from "../../../../../utils/reusableStyles";

// Constants
const PAGINATION_PADDING_X = 2;
const PAGINATION_PADDING_Y = 1.5;
const PAGE_BUTTON_SIZE = 40;

export const NewsPagination = ({
  currentPage,
  isLoading,
  canGoToNextPage,
  onPrevPage,
  onNextPage,
  onPageChange,
  getPageNumbers,
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        my: 2,
        py: PAGINATION_PADDING_Y,
        px: PAGINATION_PADDING_X,
        backgroundColor: "primary.main",
        borderRadius: theme.borderRadius.small,
      }}
    >
      {/* Previous Button */}
      <Button
        onClick={onPrevPage}
        disabled={currentPage === 0 || isLoading}
        variant="text"
        size="small"
        startIcon={<ArrowBackIosIcon />}
        disableRipple
        sx={NAVIGATION_BUTTON_STYLES}
      >
        Recent News
      </Button>

      {/* Page Numbers */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          flex: 1,
        }}
      >
        {getPageNumbers().map((page, index) =>
          page === "..." ? (
            <Typography key={index} variant="body2" sx={{ color: "primary.white" }}>
              ...
            </Typography>
          ) : (
            <Button
              key={index}
              onClick={() => onPageChange(page)}
              disabled={page === currentPage + 1}
              variant="text"
              size="small"
              sx={{
                minWidth: PAGE_BUTTON_SIZE,
                height: PAGE_BUTTON_SIZE,
                borderRadius: theme.borderRadius.border50,
                color: "primary.white",
                backgroundColor:
                  page === currentPage + 1
                    ? "primary.brandSecondary"
                    : "transparent",
                transition: "all 0.3s ease",
                fontWeight: page === currentPage + 1 ? 600 : 400,
                "&:hover": {
                  backgroundColor:
                    page === currentPage + 1
                      ? "primary.brandSecondary"
                      : "rgba(255,255,255,0.1)",
                },
                "&:disabled": {
                  color: "primary.white",
                  opacity: 1,
                },
              }}
            >
              {page}
            </Button>
          ),
        )}
      </Box>

      {/* Next Button */}
      <Button
        onClick={onNextPage}
        disabled={!canGoToNextPage || isLoading}
        variant="text"
        size="small"
        endIcon={<ArrowForwardIosIcon />}
        disableRipple
        sx={NAVIGATION_BUTTON_STYLES}
      >
        Older News
      </Button>
    </Stack>
  );
};
